import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import ModalHeader from '../../../../../Modal/components/ModalHeader/ModalHeader';
import ScoreGradebar from '../ScoreGradeBar/ScoreGradeBar';

import style from './style/allscoresoverview.scss';
import { ToxicsIcon } from '../DerailmentIcon';
import Badge from '../../../Badge/Badge';
import { TOXICS_HIGH_RISK_SCORE } from '../../constants';

const AllScoresModal = props => {
    const { i18nParticipation, sectionIconClasses, title, basedOn, scores, onClose, openSingleScaleScoreModal } = props;

    const toxicsByGroup = scores.reduce((groups, score) => {
        const name = Object.keys(score.group)[0];
        const groupIndex = groups.findIndex(group => group.name === name);

        if (groupIndex === -1) {
            groups.push({
                name,
                order: score.group[name].order,
                scores: [score]
            });

            return groups;
        }

        groups[groupIndex].scores.push(score);
        return groups;
    }, [])
        .sort((leftGroup, rightGroup) => leftGroup.order - rightGroup.order);

    const sectionIconClassesExtended = {
        root: `${sectionIconClasses.root} ${style.sectionIcon}`,
        figure: sectionIconClasses.figure
    };

    return (
        <>
            <ModalHeader classes={{ modalHeader: style.modalHeader }}>
                <header>
                    <div>
                        <Badge classes={ sectionIconClassesExtended } />
                    </div>
                    <section className={style.heading}>
                        <span>{basedOn}</span>
                        <h2>
                            {title}
                        </h2>
                    </section>
                </header>
                <button
                    type="button"
                    onClick={onClose}
                >
                    <FontAwesomeIcon icon={'times'} size="lg" />
                </button>
            </ModalHeader>

            <div className={style.container}>
                <p>
                    {i18nParticipation.report_derailment_scale_groups_explanation}
                </p>

                {toxicsByGroup.map((group, index) => (
                    <ScoresGroup
                        key={index}
                        i18nParticipation={i18nParticipation}
                        name={group.name}
                        scores={group.scores}
                        openSingleScaleScoreModal={openSingleScaleScoreModal}
                    />
                ))}
            </div>
        </>
    );
};

export default AllScoresModal;

const ScoresGroup = props => {
    const { i18nParticipation, name, scores, openSingleScaleScoreModal } = props;

    const groupLabel = i18nParticipation[`report_intermediate_${name}`];
    const groupExplanation = i18nParticipation[`report_derailment_scale_groups_${name}_explanation`];

    return (
        <div className={style.scoresGroup}>
            <h3 className={style.groupHeader}>
                {groupLabel}
            </h3>

            <p>
                {groupExplanation}
            </p>

            {scores.map((score, index) => (
                <div key={index} className={style.scoreRow}>
                    <div
                        className={style.scoreName}
                        data-scale-handle={score.handle}
                        role='button'
                        tabIndex={0}
                        onClick={openSingleScaleScoreModal}>
                        <div>
                            <ToxicsIcon scaleHandle={score.handle} score={score.score} className={style.iconDerailerContainer}/>
                        </div>

                        <div className={style.nameContainer}>
                            <p className={style.scaleName}>
                                {score.name}
                                <FontAwesomeIcon icon={'chevron-right'} size="sm" color='red' className={style.chevronRight} />
                            </p>

                            {score.score >= TOXICS_HIGH_RISK_SCORE ? (
                                <small>
                                    {i18nParticipation[`report_derailment_scale_${score.handle}_definition`]}
                                </small>
                            ) : null}
                        </div>

                        <div />
                    </div>

                    <div className={style.scoreBar}>
                        <ScoreGradebar i18nParticipation={i18nParticipation} score={score.score} hasLabels={index === 0} />
                    </div>
                </div>
            ))}
        </div>
    );
};
